import { DefaultTheme, ThemeProps } from 'styled-components';
import { dark, light } from '@mewssystems/design-tokens';

export const getToken =
    <TokenName extends keyof typeof light & keyof typeof dark>(tokenName: TokenName) =>
    (props: ThemeProps<DefaultTheme>) =>
        props.theme.designTokens[tokenName];
